/** A session kind's icon (TMMAPP-0153, visual contract v2 §12): people, branch, lock or help. */
import { BranchIcon, HelpIcon, LockIcon, UsersIcon } from '@/components/icons';
import type { SessionKind } from './sessionKind';

/** Icons are 16 px inline; the list's tags draw them at 13 (contract §12). */
export function SessionKindIcon({ kind, size = 16 }: { kind: SessionKind; size?: number }) {
  if (kind === 'shared') return <UsersIcon size={size} />;
  if (kind === 'breakout') return <BranchIcon size={size} />;
  if (kind === 'support') return <HelpIcon size={size} />;
  return <LockIcon size={size} />;
}
